<template>
  <Modal class="text-center font-weight-normal" type="modal-sm">
    <IconImportant height="50" class="active mb-3" />
    <p>AMP Preview <span v-if="!supported">of {{type}}s </span>is not available <span v-if="supported">for the demo {{type}}</span><span v-else>in {{plan|upperFirst}} plan</span>.</p>
    <button class="btn btn-primary mb-2" @click="change" v-if="supported">Select a {{type}} from your store</button><br v-if="supported">
    <button class="btn btn-link text-danger" @click="cancel"><span v-if="supported">Cancel</span><span v-else>Close</span></button>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import Modal from '@/components/Modal'
import filters from '@/mixins/filters'

export default {
  mixins: [ filters ],
  components: {
    Modal
  },
  props: {
    type: String,
    supported: Boolean
  },
  computed: mapState([ 'plan' ]),
  methods: {
    change: function () {
      this.$emit('change')
    },
    cancel: function () {
      this.$emit('cancel')
    }
  }
}
</script>
